import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as CatalogActions from './catalog.actions';
import * as IotAssetActions from '../iotAssets/iotAsset.actions';
import { selectCatalogData, selectLastLoadedCustomerId } from './catalog.selectors';
import { CatalogState } from './catalog.reducer';
import { CatalogService } from '../../services/catalog.service';
import { DataService } from '../../services/data.service';
import { getApplySelectedCustomer } from '../selectors';
import { AppStateInterface } from 'src/app/appState.interface';

@Injectable()
export class CatalogEffects {
  loadCatalog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CatalogActions.loadCatalog),
      withLatestFrom(
        this.store.select(selectCatalogData),
        this.store.select(selectLastLoadedCustomerId),
        this.store.select(getApplySelectedCustomer)
      ),
      switchMap(([_, catalogData, lastCustomerId, selectedCustomer]) => {
        const currentCustomerId = selectedCustomer?.uid;

        if (catalogData && lastCustomerId && lastCustomerId === currentCustomerId) {
          return EMPTY;
        }

        return this.catalogService.getCatalog().pipe(
          map((catalog) => CatalogActions.loadCatalogSuccess({ catalog, customerId: currentCustomerId!, customerName: selectedCustomer?.name ?? '' })),
          catchError((error) =>
            of(CatalogActions.loadCatalogFailure({ error: error.message }))
          )
        );
      })
    )
  );

  loadMappingConfigOnCatalogLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CatalogActions.loadCatalogSuccess),
      switchMap(({ customerId }) => {
        const userInfo = this.dataService.getCurrentUserInfo();
        const uidUser = userInfo.user?.uid;

        if (!customerId || !uidUser) return EMPTY;

        return this.catalogService.getMappingConfigFromAPI(customerId, uidUser).pipe(
          map((configs) => {
            const mappingData = configs?.[0]?.config?.mappingData;
            if (!mappingData) return { type: '[Catalog] No Mapping Config' };
            return IotAssetActions.saveMappingConfig({ mappingConfig: mappingData });
          }),
          catchError(() => EMPTY)
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private catalogService: CatalogService,
    private dataService: DataService,
    private store: Store<AppStateInterface & { catalog: CatalogState }>
  ) {}
}
